import type { SelectHTMLAttributes } from "react";
import { cx } from "./cx";
import { ChevronDown, Icon } from "./icon";

export interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  error?: boolean;
}

/** Styled native select — token chrome, custom chevron, full a11y for free. */
export function Select({ error = false, className, children, ...rest }: SelectProps) {
  return (
    <span className={cx("pz-select-wrap", className)}>
      <select className={cx("pz-input", error && "pz-input--error")} aria-invalid={error || undefined} {...rest}>
        {children}
      </select>
      <span className="pz-select-chevron">
        <Icon icon={ChevronDown} size="sm" />
      </span>
    </span>
  );
}
